export const getTreeMapDisplayText = (
  name: string | undefined,
  width: number,
  height: number
): string => {
  // Check if name is undefined or not a string
  if (!name || typeof name !== 'string') {
    return ''; // Return an empty string if name is invalid
  }

  const maxChars = Math.floor(width / 10); // Calculate max characters based on width
  if (width < 68) return ''; // Remove text if the area is too small

  return name.length > maxChars ? `${name.substring(0, maxChars - 2)}..` : name;
};
